import React from 'react';

const CustomZoomRadiusHelpText = ({ className = 'custom-create-page__hint' }) => (
  <p className={className}>
    Zoom radius controls how much of the image is visible at the start. Lower values zoom in more
    (harder), while higher values zoom out more (easier).
  </p>
);

export default CustomZoomRadiusHelpText;
